// "Settings for @handle — each LinkedIn account has its own." Shown on per-account settings.

import { Avatar } from "@ml/ui";
import { IgGlyph } from "../IgGlyph";
import { useIgAccount } from "../../lib/igAccount";
import "./ig-workspaces.css";

export function IgScopeNote({ subject = "Settings" }: { subject?: string }) {
  const { current, accounts, isLoading } = useIgAccount();
  if (isLoading) return null;
  if (!current) {
    return (
      <p className="gfp-ws-scope">
        <span className="gfp-ws-scope__icon" aria-hidden="true">
          <IgGlyph size={14} />
        </span>
        <span>
          No LinkedIn account connected yet. These are the defaults your first account starts with; every account
          then keeps its own.
        </span>
      </p>
    );
  }
  return (
    <p className="gfp-ws-scope">
      <Avatar src={current.profilePicUrl} name={current.fullName || current.username} size={20} />
      <span>
        {subject} for <b className="gfp-strong">@{current.username}</b> — each LinkedIn account has its own.
        {accounts.length > 1 ? " Switch accounts at the top to edit another." : null}
      </span>
    </p>
  );
}
